/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { ComponentType } from 'react';

import { LazyLoadedComponent } from '../../components/LazyLoadedComponent';

interface SubscriptionPlansFile {
    SubscriptionPlans: ComponentType<any>;
}

export const SubscriptionPlansPage = () => (
    <LazyLoadedComponent<SubscriptionPlansFile>
        importPromise={() => (import('./components/SubscriptionPlans') as Promise<SubscriptionPlansFile>)}
        pageName={'SubscriptionPlans'}
    />
);
